import { React, useContext, useEffect, useState, } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import IndustryFilter from "../../Components/RefineSearchComponents/IndustryFilter";
import SectorFilter from "../../Components/RefineSearchComponents/PESectorFilter";
import YearFoundedFilter from "../../Components/RefineSearchComponents/YearFoundedFilter";
import CountryFilter from "../../Components/RefineSearchComponents/CountryFilter";
import RegionFilter from "../../Components/RefineSearchComponents/RegionFilter";
import StateFilter from "../../Components/RefineSearchComponents/StateFilter";
import CityFilter from "../../Components/RefineSearchComponents/CityFilter";
import VcFundedFilter from "../RefineSearchComponents/VcFundedFilter";
import ExitedFilter from "../RefineSearchComponents/ExitedFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import { useLocation,  useNavigate } from "react-router";
import axios from "axios";
import { filterLocationUrl, filterSectorByIndutry, tagList } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import DefinitionModal from "../TagDefinitionModal";
import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
/**
 * The `AngelRefineSearch` function is a React component that renders a form for refining search
 * filters in an angel investment application.
 * @returns a JSX element, which represents the UI of the component.
 */
function AngelRefineSearch({ customPathname, generalPathname }) {
    const {
        setrefineSearchFilters,dbDropdown , setDbDropdown ,
        refineSearchFilters,SwitchState,setSwitchState,dropdown,checkToggleBtn,setToggleDealsBtn,
        angelInvestorOptions, setAngelInvestorOptions, TargetCompanyOptions , setTargetCompanyOptions ,
        setSectors,lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions ,
        onErrorHandler,setMonthPickerValue, getSectorByIndustry, accessControl } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const navigate = useNavigate();
    const { getToken } = useContext(UserContext);
    // const isMatch = useMatch({ path: routeNames.pe_companies_angel_investments })
    const location = useLocation();
    const {pathname} = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false



    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [CountryOptions, setCountryOptions] = useState([])
    const [RegionOptions, setRegionOptions] = useState([])
    const [StateOptions, setStateOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [EndYearOptions, setEndYearOptions] = useState([]);
    const [StartYearOptions, setStartYearOptions] = useState([])
    const [TagSwitchState, setTagSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])
    const [VCFundedOptions, setVCFundedOptions] = useState([])
    const [ExitedOptions, setExitedOptions] = useState([])
    const [FirmTypeOptions, setFirmTypeOptions] = useState([])
    
    // Centralized popup state management - only one filter popup can be open at a time
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    useEffect(() => {
        const ids = IndustriesOptions?.length > 0 ? 
            IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];

        if (ids?.length > 0) {
            getSectorByIndustry(ids, "investments")
        } else {
            setSectors([])
        }

    }, [IndustriesOptions])

    useEffect(() => {
        if(accessControl?.peindustries?.id?.length > 0){
            const ids = accessControl ? accessControl?.peindustries?.id : []
            getSectorByIndustry(ids, "investments")
        }
    }, [])

 /**
  * The `onCountryChange` function takes in an array of options, filters the checked options, and makes
  * a POST request to a specified URL with the filtered options as parameters, then updates the region,
  * state, and city options based on the response data.
  * @param options - The `options` parameter is an array of objects. Each object represents an industry
  * and has the following properties:
  */
    const onCountryChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: ids,
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setRegionOptions(response.data?.region)
                setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

   /**
    * The `onRegionChange` function takes in options and filters them based on whether they are
    * checked, then makes a POST request to a specified URL with the selected countries and regions,
    * and updates the state and city options based on the response.
    * @param options - The `options` parameter is an array of objects. Each object represents an
    * industry and has the following properties:
    */
    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

  /**
   * The `onStateChange` function sends a POST request to a specified URL with selected country,
   * region, and state options, and updates the city options based on the response.
   * @param options - The `options` parameter is an array of objects that represent industries. Each
   * object has the following properties:
   */
    const onStateChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: selectedRegion,
            state: ids,
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }


   /**
    * The function `applyFilter` updates the refine search filters based on the selected options.
    */
    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = SectorOptions.filter(option => option.isChecked);
        const selectedStartYear = StartYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedEndYear = EndYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedCountries = CountryOptions?.filter(option => option.isChecked);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedState = StateOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedVc = VCFundedOptions?.filter(option => option.isChecked);
        const selectedExited = ExitedOptions?.filter(option => option.isChecked);
        const selectedOperators = SwitchState;
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = angelInvestorOptions?.filter(option => option.isChecked);
        const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                yearFounded: selectedEndYear != null && selectedStartYear != null ? [selectedStartYear, selectedEndYear] : [],
                countries: selectedCountries,
                region: selectedRegion,
                state: selectedState,
                city: selectedCity,
                tags: TagsOptions,
                operator: TagSwitchState ? 1 : 0,
                target_company:selectedTargetCompany,
            },
            [customPathname]: {
                ...prev[customPathname],
                exited: selectedExited,
                firmType: selectedFirm,
                deals_operator : selectedOperators,
                investor_id : selectedInvestor ,
                vcFunded: selectedVc,
            },
        }))
        checkToggleBtn();
    }

   /**
    * The function `resetFilter` resets a specific filter in the `refineSearchFilters` state object by
    * setting its value to an empty object.
    */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {},
            [customPathname]: {}
        }))
        setTargetCompanyOptions([]);
        setAngelInvestorOptions([]);
        setSectors([]);
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setToggleDealsBtn(true);
    }
    useEffect(()=>{
        setToggleDealsBtn(true);
      },[customPathname])


    // Submitting Refine Search Form 
   /**
    * The function `refineSearchFilter` updates search filters, resets the month picker value, sets the
    * current page to 1, applies the filter, navigates to a custom pathname if necessary, and sets the
    * selected state to false.
    * @param event - The event parameter is an object that represents the event that triggered the
    * function. It contains information about the event, such as the target element, the type of event,
    * and any additional data associated with the event. In this case, it is used to prevent the
    * default behavior of the event, which is
    */
    const refineSearchFilter = (event) => {
         setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
            },
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();
      
        setCurrentPage(1);
        // if (isMatch == null) {
        //     navigate(routeNames.pe_companies_angel_investments);
        // }
        applyFilter();
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
        setSelected(false)

    }

    useEffect(()=> {
            setrefineSearchFilters(prev => ({
                ...prev,
                [generalPathname]:{
                    ...prev[generalPathname],
                    exitStatus:[],
                    firmType:[],
                    firm_Sub_type:[],
                    investor_id: [],
                    ladvisors: [],
                    tadvisors: []
                }
            }))
        }, [])

  /**
   * The `onResetClick` function resets the current page, filters, and navigates to a custom pathname
   * if it is different from the current location.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. In this case, it is the click event that occurred when the user clicked on a reset
   * button or link.
   */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null) {
        //     navigate(routeNames.pe_companies_angel_investments);
        // }
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

  /**
   * The function `accordionClick` sets the selected value to 0 if it is equal to `select`, otherwise
   * it sets it to the provided value.
   * @param val - The `val` parameter is the value that is passed to the `accordionClick` function. It
   * is used to determine which accordion item should be selected.
   */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };
    useEffect(() => {
        const countryIds = refineSearchFilters[generalPathname]?.countries?.map(value => value.id) ?? [];
        const ids = refineSearchFilters[generalPathname]?.region?.map(value => value.id) ?? [];
        const stateIds = refineSearchFilters[generalPathname]?.state?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[generalPathname]?.city?.map(value => value.id) ?? [];
        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: countryIds.includes(option.id) })))
                setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
                setStateOptions(response.data.state?.map(option => ({ ...option, isChecked: stateIds.includes(option.id) })))
                setCityOptions(response.data.city?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters])

    const getSearchTags = async (searchText, type) => {
        try {
        const response = await axios.post(tagList, {
            "tag": searchText,
            "includes_secondary_tags": secondaryTagCheck,
            "type"    : type

        }, {
            headers: {
            "Authorization": getToken()
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
        } catch (error) {
            return [];
        }
    }


    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor")
        const secondaryTags = await getSearchTags("ALL", "secondary")
        // console.log(tags, competitorTags, 'promi')
        openTagModal(tags, competitorTags, secondaryTags)
    };
        
    const  [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);
    const [activeFilterSection, setActiveFilterSection] = useState('keyword');
    // console.log(defValues, 'showValues');

    // Count functions for filter badges
    const countKeywordFilters = () => {
        const hasTags = TagsOptions?.some(tag => tag.isChecked) ? 1 : 0;
        const hasInvestor = angelInvestorOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasTargetCompany = TargetCompanyOptions?.some(opt => opt.isChecked) ? 1 : 0;
        
        return hasTags + hasInvestor + hasTargetCompany;
    };

    const countDealFilters = () => {
        const hasYearFounded = (StartYearOptions?.some(option => option.isChecked) || EndYearOptions?.some(option => option.isChecked)) ? 1 : 0;
        const hasVcFunded = VCFundedOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasExited = ExitedOptions?.some(opt => opt.isChecked) ? 1 : 0;
        
        return hasYearFounded + hasVcFunded + hasExited;
    };

    const countCompanyFilters = () => {
        const hasIndustry = IndustriesOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasSector = SectorOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasCountry = CountryOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasRegion = RegionOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasState = StateOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasCity = CityOptions?.some(opt => opt.isChecked) ? 1 : 0;
        
        return hasIndustry + hasSector + hasCountry + hasRegion + hasState + hasCity;
    };

    const countInvestorFilters = () => {
        const hasFirmType = FirmTypeOptions?.some(opt => opt.isChecked) ? 1 : 0;
        
        return hasFirmType;
    };

    const openTagModal = (non_comp, comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () =>{
        setShowDefinitionModal(false);
        setDefValues({})
    }


    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };
    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full flex flex-col">
                    <main className="flex-1 w-full md:py-4 overflow-y-auto">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left Sidebar - Filter Categories */}
                                <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">
                                <div 
                                    className={`cursor-pointer p-2 xs:p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs xs:text-sm md:text-base font-medium">Keyword Search</span>
                                            {countKeywordFilters() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {countKeywordFilters()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                <div 
                                    className={`cursor-pointer p-2 xs:p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs xs:text-sm md:text-base font-medium">Deal</span>
                                            {countDealFilters() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {countDealFilters()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                <div 
                                    className={`cursor-pointer p-2 xs:p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs xs:text-sm md:text-base font-medium">Company</span>
                                            {countCompanyFilters() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {countCompanyFilters()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                <div 
                                    className={`cursor-pointer p-2 xs:p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'investor' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'investor' ? null : 'investor')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs xs:text-sm md:text-base font-medium">Investor</span>
                                            {countInvestorFilters() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'investor' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {countInvestorFilters()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'investor' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>
                            </div>

                            {/* Right Content Area - Filter Options */}
                            <div className="overflow-visible pb-20 md:pb-0 md:col-span-6">
                                {/* Keyword Search Section */}
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'}`}>
                                    <div className="space-y-4">
                                        <div className="flex items-center gap-4 border border-gray-300 rounded-md p-1 md:gap-0">
                                            <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                                <Tags
                                                    TagsOptions={TagsOptions}
                                                    customPathname={generalPathname}
                                                    setTagsOptions={setTagsOptions} 
                                                    getSearchTags={getSearchTags}
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                />
                                                <Switch
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                    customPathname={generalPathname} 
                                                />
                                            </div>
                                            <div className="flex items-center px-2">
                                                <Tooltip title='Tag List'>
                                                    <FaInfoCircle 
                                                        size={16} 
                                                        color="grey" 
                                                        className="cursor-pointer"
                                                        onClick={fetchData}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                                            <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                                            <span>include secondary tags</span>
                                        </div>
                                        <div className="space-y-4">
                                            <Investor 
                                                options={angelInvestorOptions}
                                                setOptions={setAngelInvestorOptions}
                                                customPathname={customPathname}
                                                accordionClick={() => accordionClick(32)}
                                                label="Investor"
                                                open={select === 32}
                                            />
                                            <TargetCompany 
                                                options={TargetCompanyOptions}
                                                setOptions={setTargetCompanyOptions}
                                                customPathname={generalPathname}
                                                accordionClick={() => accordionClick(31)}
                                                label="Company"
                                                open={select === 31}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Deal Section */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                        <VcFundedFilter
                                            VCFundedOptions={VCFundedOptions}
                                            setVCFundedOptions={setVCFundedOptions}
                                            customPathname={customPathname}
                                            heading="VC Funded"
                                            isPopupOpen={openFilterPopup === 'vcFunded'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'vcFunded' : null)} />
                                        <ExitedFilter
                                            ExitedOptions={ExitedOptions}
                                            setExitedOptions={setExitedOptions}
                                            customPathname={customPathname}
                                            isPopupOpen={openFilterPopup === 'exited'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'exited' : null)} />
                                        
                                    </div>

                                {/* Company Section */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                                        <IndustryFilter
                                            IndustriesOptions={IndustriesOptions}
                                            setIndustriesOptions={setIndustriesOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(1)}
                                            open={select === 1}
                                            isPopupOpen={openFilterPopup === 'industry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)} />
                                        <SectorFilter
                                            SectorOptions={SectorOptions}
                                            setSectorOptions={setSectorOptions}
                                            accordionClick={() => accordionClick(2)}
                                            customPathname={generalPathname}
                                            open={select === 2}
                                            isPopupOpen={openFilterPopup === 'sector'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)} />
                                        <YearFoundedFilter
                                            EndYearOptions={EndYearOptions}
                                            customPathname={generalPathname}
                                            setEndYearOptions={setEndYearOptions}
                                            StartYearOptions={StartYearOptions}
                                            setStartYearOptions={setStartYearOptions}
                                            isPopupOpen={openFilterPopup === 'yearFounded'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'yearFounded' : null)} />
                                        <CountryFilter
                                            CountryOptions={CountryOptions}
                                            setCountryOptions={setCountryOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(10)}
                                            onChange={onCountryChange}
                                            open={select === 10}
                                            isPopupOpen={openFilterPopup === 'country'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'country' : null)} />
                                        <RegionFilter
                                            RegionOptions={RegionOptions}
                                            setRegionOptions={setRegionOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(11)}
                                            onChange={onRegionChange}
                                            open={select === 11}
                                            isPopupOpen={openFilterPopup === 'region'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'region' : null)} />
                                        <StateFilter
                                            StateOptions={StateOptions}
                                            setStateOptions={setStateOptions}
                                            customPathname={generalPathname}
                                            onChange={onStateChange}
                                            accordionClick={() => accordionClick(12)}
                                            open={select === 12}
                                            isPopupOpen={openFilterPopup === 'state'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'state' : null)} />
                                        <CityFilter
                                            CityOptions={CityOptions}
                                            setCityOptions={setCityOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(13)}
                                            open={select === 13}
                                            isPopupOpen={openFilterPopup === 'city'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)} />
                                </div>

                                {/* Investor Section */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-y-8 ${activeFilterSection === 'investor' ? '' : 'hidden'}`}>
                                        
                                        <FirmTypeFilter
                                            FirmTypeOptions={FirmTypeOptions}
                                            setFirmTypeOptions={setFirmTypeOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(16)}
                                            dataPath="angel"
                                            open={select === 16}
                                            isPopupOpen={openFilterPopup === 'firmType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)} />
                                        
                                </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal 
                    values={defValues} 
                    onClose={defCloseHandler} 
                    TagsOptions={TagsOptions} 
                    setTagsOptions={setTagsOptions}
                    customPathname={generalPathname}
                />}
        </div>
    )
}

export default AngelRefineSearch